<template>
  <div>
    <div class="top-name-div">
      {{ auctionMeeting.meetingName }}
    </div>
    <div>
      <div class="top-button-div">
        <img class="top-left-button cursor-pointer" src="../../../public/img/change-button.png"
             @click="changeScrollLeft(1)">
      </div>
      <div id="lotScroll" class="top-lot-list-div">
        <div id="lotListDiv" :style="'width:'+lotsOutClass+'px'" class="lot-item-out-div">
          <div v-for="m in lotsList" :key="m.id" class="lot-item-img">
            <!-- 视频缩略图 -->
            <div v-if="isVideoFile(m.lotImg[0].link)" class="video-thumbnail-container">
              <video
                  :id="m.id"
                  :src="m.lotImg[0].link"
                  class="lot-img-class video-thumbnail"
                  muted
                  playsinline
                  preload="metadata"
                  @click="changeLot(m.id)"
                  @loadeddata="onVideoLoaded(m.id)"
              ></video>
              <div class="video-play-overlay" @click="changeLot(m.id)">
                <i class="el-icon-video-play video-play-icon"></i>
              </div>
              <p class="li-name">{{ m.lotName }}</p>
            </div>

            <!-- 图片缩略图 -->
            <div v-else>
              <img
                  :id="m.id"
                  :onerror="handleImageError"
                  :src="m.lotImg[0].link"
                  class="lot-img-class"
                  @click="changeLot(m.id)"
              >
              <p class="li-name">{{ m.lotName }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="top-button-div">
        <img class="top-right-button cursor-pointer" src="../../../public/img/change-button.png"
             @click="changeScrollLeft(2)">
      </div>
    </div>
  </div>
</template>

<script>
import {listByMeetingId} from '@/api/biz/auction/auctionLot'

export default {
  name: "HallLotList",
  props: ['meetingId', 'outLotId'],
  data() {
    return {
      letQueryName: '',
      lotsList: [],
      activeLotId: null,
      lotInfo: {
        meetingType: null,
      },
      auctionMeeting: {},
      lotsOutClass: 1030,
      videoThumbnails: {}, // 存储视频缩略图信息
      defaultVideoThumbnail: '', // 默认视频封面图
    }
  },
  watch: {
    activeLotId(val) {
      this.$router.push({path: "/lotDetail", query: {lotId: val}})
      this.$emit('changeLotId', val)
      this.$emit('lotChanged', val)
    }
  },
  mounted() {
    // 可以设置一个默认的视频封面图
    this.defaultVideoThumbnail = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjE0NSIgdmlld0JveD0iMCAwIDIwMCAxNDUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjIwMCIgaGVpZ2h0PSIxNDUiIGZpbGw9IiMyRjJGMkYiLz48cGF0aCBkPSJNODQgNzIuNUw4NCA3Mi41Vjk2LjVMMTAwIDg0LjVMMTExIDcyLjVWNzIuNUg4NFoiIGZpbGw9IndoaXRlIi8+PC9zdmc+';
  },
  methods: {
    // 判断是否为视频文件
    isVideoFile(url) {
      if (!url) return false;
      const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.avi', '.wmv', '.flv', '.m3u8', '.mkv'];
      const lowerUrl = url.toLowerCase();
      return videoExtensions.some(ext => lowerUrl.endsWith(ext));
    },

    // 视频加载完成时设置封面
    onVideoLoaded(videoId) {
      const videoElement = document.getElementById(videoId);
      if (videoElement) {
        // 尝试从视频中获取一帧作为封面
        this.setVideoThumbnail(videoElement, videoId);
      }
    },

    // 设置视频缩略图
    setVideoThumbnail(videoElement, videoId) {
      try {
        // 设置视频当前时间到中间位置，获取更好的封面
        if (videoElement.duration > 0) {
          videoElement.currentTime = videoElement.duration * 0.1; // 取10%的位置
        }

        // 创建canvas来截取视频帧
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = 200;
        canvas.height = 145;

        // 监听timeupdate事件，确保视频已加载到指定位置
        const captureFrame = () => {
          if (videoElement.readyState >= 2) { // HAVE_CURRENT_DATA
            ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
            const thumbnailUrl = canvas.toDataURL('image/jpeg', 0.8);
            this.$set(this.videoThumbnails, videoId, thumbnailUrl);
            videoElement.removeEventListener('timeupdate', captureFrame);
          }
        };

        videoElement.addEventListener('timeupdate', captureFrame);

        // 超时处理
        setTimeout(() => {
          videoElement.removeEventListener('timeupdate', captureFrame);
          if (!this.videoThumbnails[videoId]) {
            this.$set(this.videoThumbnails, videoId, this.defaultVideoThumbnail);
          }
        }, 1000);

      } catch (error) {
        console.error('生成视频缩略图失败:', error);
        this.$set(this.videoThumbnails, videoId, this.defaultVideoThumbnail);
      }
    },

    // 获取视频封面URL
    getVideoThumbnail(videoId) {
      return this.videoThumbnails[videoId] || this.defaultVideoThumbnail;
    },

    // 图片加载失败处理
    handleImageError(event) {
      event.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjE0NSIgdmlld0JveD0iMCAwIDIwMCAxNDUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjIwMCIgaGVpZ2h0PSIxNDUiIGZpbGw9IiMyRjJGMkYiLz48cGF0aCBkPSJNODAgNTBMODAgOTVMMTIwIDcyLjVMNjAgNTBaIiBmaWxsPSIjNjY2Ii8+PC9zdmc+';
    },

    changeScrollLeft(type) {
      let dom = document.getElementById("lotScroll");
      if (type == 1) {
        dom.scrollLeft = dom.scrollLeft - 228;
      } else if (type == 2) {
        dom.scrollLeft = dom.scrollLeft + 228;
      }
    },
    changeLot(lotId) {
      this.activeLotId = lotId;
      this.lotsList.forEach(e => {
        const element = document.getElementById(e.id);
        if (element) {
          if (element.tagName === 'VIDEO') {
            element.style.borderColor = 'transparent';
          } else {
            element.style.borderColor = 'transparent';
          }
        }
      })
      const currentElement = document.getElementById(lotId);
      if (currentElement) {
        currentElement.style.borderColor = 'red';
      }
    },
    queryLotsByMeetingId(id) {
      listByMeetingId(id).then(res => {
        this.lotsList = res.data.data;
        this.lotsOutClass = 228 * this.lotsList.length
        console.log(this.lotsOutClass)
        this.lotInfo = this.lotsList[0];
        this.auctionMeeting = this.lotsList[0].auctionMeeting;
        this.$emit('getMeetingData', this.auctionMeeting)
        if (this.outLotId) {
          this.$nextTick(() => {
            const element = document.getElementById(this.outLotId);
            if (element) {
              element.style.borderColor = 'red';
            }
          })
        }
      })
    }
  },
  created() {
    if (this.meetingId) {
      this.queryLotsByMeetingId(this.meetingId)
    }
  }
}
</script>

<style scoped>
.lot-item-out-div {
  min-width: 1030px;
  display: inline-block;
  padding-right: 1px;
}

/* 基础图片样式 */
.lot-img-class {
  width: 200px;
  height: 145px;
  border: 2px solid #fff;
  object-fit: cover;
  display: block;
}

/* 视频缩略图特殊样式 */
.video-thumbnail {
  position: relative;
  background-color: #000;
}

.video-thumbnail-container {
  position: relative;
  display: block;
  width: 200px;
  height: 145px;
}

.video-play-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.video-play-overlay:hover {
  background: rgba(0, 0, 0, 0.5);
}

.video-play-icon {
  font-size: 48px;
  color: rgba(255, 255, 255, 0.9);
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.lot-item-img {
  margin-left: 13px;
  margin-right: 13px;
  display: inline-block;
  width: 200px;
  height: 150px;
  opacity: 1;
  box-sizing: content-box;
}

.cursor-pointer:hover {
  cursor: pointer;
  box-shadow: 1px 0px 3px rgba(0, 0, 0, 0.35);
}

.top-button-div {
  width: 80px;
  display: inline-block;
  line-height: 180px;
  vertical-align: bottom;
  height: 180px;
}

.top-lot-list-div {
  display: inline-block;
  overflow: hidden;
  width: 1130px;
  margin-top: 30px;
  height: 150px;
}

.top-left-button {
  margin-left: 35px;
  margin-top: 15px;
  transform: rotate(180deg);
  border-radius: 20px;
}

.top-right-button {
  margin-left: 20px;
  margin-top: 15px;
  border-radius: 21px;
}

.top-name-div {
  padding-left: 30px;
  height: 60px;
  /** 文本1 */
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 60px;
  color: rgba(0, 0, 0, 1);
  border-bottom: 1px solid rgba(233, 237, 242, 1);
}

.pic-top {
  z-index: 0;
  text-align: left;
  margin-left: 5px;
}

.li-name {
  position: relative;
  z-index: 1;
  margin-left: 2px;
  margin-top: -32px;
  width: 200px;
  height: 30px;
  opacity: 1;
  background: rgba(0, 0, 0, 0.4);
  /** 文本1 */
  font-size: 14px;
  font-weight: 400;
  line-height: 30px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.li-type {
  color: #fff;
  margin-top: -32px;
}

.li-content {
  display: grid;
  text-align: center;
}

.list-li {
  float: left;
  margin-right: 20px;
}

.meeting-title {
  font-size: 20px;
  color: #333;
  margin-bottom: 20px;
}

.meeting-info {
  color: rgb(102, 102, 102);
  margin-top: 20px;
  margin-left: 10px;
}

.meeting-img-list {
  margin-left: 10px;
  display: inline-block;
  margin-top: 20px;
}
</style>
